const types = [
    { value: 1, name: '报废' },
    { value: 2, name: '破损' },
    { value: 3, name: '出售' },
    { value: 4, name: '盘亏' },
    { value: 5, name: '调出' },
    { value: 6, name: '退租' },
    { value: 7, name: '捐赠' },
    { value: 8, name: '其他' },
]

const getName = (type) => {
    const item = types.find(item => {
        return type == item.value;
    })

    if (item) {
        return item.name;
    } else {
        return '';
    }

}

export {
    types,
    getName
}